<template>
    <div class="advanced-filter-dropdown-container">
    
        <div v-if='field_type=="date_range"'>
            <div class="mb-2">
                <div class="d-flex justify-content-between align-items-center mb-1">
                    <label class="form-label mb-0">{{ field_label.toLowerCase() == 'start date' ? field_label : field_label + ' - Start' }}</label>
                    <button v-if="if_allow_delete && !filter.is_required" class="btn btn-icon-only-sm btn-warning p-0 remove-filter-btn" data-bs-toggle="tooltip" title="Remove filter" @click="deleteFilter" type="button" >
                        <img class="icon" src="/img/icons/avid-icons/trash-01.svg" alt="Remove">
                    </button>
                </div>
                <datepicker-utc 
                    v-model="local_options_selected.start_date" 
                    input-class="form-control date" 
                    @update:modelValue="emitEvent()"
                />
            </div>
            <div>
                <div class="d-flex justify-content-between align-items-center mb-1">
                    <label class="form-label mb-0">{{ field_label.toLowerCase() == 'end date' ? field_label : field_label + ' - End' }}</label>
                </div>
                <datepicker-utc 
                    v-model="local_options_selected.end_date" 
                    input-class="form-control date" 
                    @update:modelValue="emitEvent()"
                />
            </div>
        </div>
        <div v-if='field_type=="month_range"'>
            <div class="mb-2">
                <div class="d-flex justify-content-between align-items-center mb-1">
                    <label class="form-label mb-0">{{ field_label == 'Start Month' ? field_label : field_label + ' - Start' }}</label>
                    <button v-if="if_allow_delete && !filter.is_required" class="btn btn-icon-only-sm btn-warning p-0 remove-filter-btn" data-bs-toggle="tooltip" title="Remove filter" @click="deleteFilter" type="button" >
                        <img class="icon" src="/img/icons/avid-icons/trash-01.svg" alt="Remove">
                    </button>
                </div>
                <datepicker-utc 
                    v-model="local_options_selected.start_date" 
                    input-class="form-control date" 
                    :monthPicker="true"
                    inputFormat="MMM yyyy"
                    @update:modelValue="emitEvent()"
                />
            </div>
            <div>
                <div class="d-flex justify-content-between align-items-center mb-1">
                    <label class="form-label mb-0">{{ field_label == 'End Month' ? field_label : field_label + ' - End' }}</label>
                </div>
                <datepicker-utc 
                    v-model="local_options_selected.end_date" 
                    input-class="form-control date" 
                    :monthPicker="true"
                    inputFormat="MMM yyyy"
                    @update:modelValue="emitEvent()"
                />
            </div>
        </div>
        <div class="advanced-filter-dropdown-month-picker" v-if='field_type=="month_picker"'>
            <div class="d-flex justify-content-between align-items-center mb-1">
                <label class="form-label mb-0">{{ field_label }}</label>
                <button v-if="if_allow_delete && !filter.is_required" class="btn btn-icon-only-sm btn-warning p-0 remove-filter-btn" data-bs-toggle="tooltip" title="Remove filter" @click="deleteFilter" type="button" >
                    <img class="icon" src="/img/icons/avid-icons/trash-01.svg" alt="Remove">
                </button>
            </div>
            <div v-if="local_options && local_options.includes('Loading Options...')">Loading Options...</div>
            <div v-else class="row month-picker-grid mx-1">
                <div v-for="month in month_order" class="col-3 text-center month-grid py-2 px-1" @click="changeMonthValue(month)" :class="!local_options.includes(month)? 'month-grid-disabled':''">
                    <div v-if="!local_options.includes(month)"> {{month}}</div>
                    <div v-else :class="local_options_selected && local_options_selected.includes(month)? 'month-grid-checked':'month-grid-unchecked'" >{{month}}</div>
                </div> 
            </div>
        </div>
        <div class="advanced-filter-dropdown-numeric-slider" v-if='field_type=="numeric_slider"' >
            <div class="d-flex justify-content-between align-items-center mb-1">
                <label class="form-label mb-0">{{ field_label }}</label>
                <button v-if="if_allow_delete && !filter.is_required" class="btn btn-icon-only-sm btn-warning p-0 remove-filter-btn" data-bs-toggle="tooltip" title="Remove filter" @click="deleteFilter" type="button" >
                    <img class="icon" src="/img/icons/avid-icons/trash-01.svg" alt="Remove">
                </button>
            </div>
            <div class="ms-2 me-3">
                <VueSlider v-if="local_options_selected[0] >= slider_min && local_options_selected[1] <= slider_max" v-model="local_options_selected"
                    class="single-color-slider" :min="slider_min" :max="slider_max" :interval="1" :dot-attrs="{ 'aria-label': (field_label || 'Range') + ' filter' }" @dragEnd="emitEvent()" />
            </div>
            <div class="row d-none"> <!--d-flex-->
                <div class="col-6">
                    <label class="form-label">Min</label>
                    <input type="number" class="form-control" v-model="local_options_selected[0]" :min="slider_min" :max="local_options_selected[1]" aria-label="Min">
                </div>
            
                <div class="col-6">
                    <label class="form-label">Max</label>
                    <input type="number" class="form-control" v-model="local_options_selected[1]"  :min="local_options_selected[0]" :max="slider_max" aria-label="Max">                                    
                </div>
            </div>
        </div>
        <div class="advanced-filter-dropdown-multi-select" v-else-if="field_type=='multi_select' || field_type=='array_multi_select'" :hidden="if_field_hidden">
            <div v-if="(filter.options && filter.options.length>0 ) || num_searches > 0 || search_key != ''" class="d-flex justify-content-between align-items-center mb-1">
                <label class="form-label mb-0">{{ field_label }}</label>
                <button v-if="if_allow_delete && !filter.is_required" class="btn btn-icon-only-sm btn-warning p-0 remove-filter-btn" data-bs-toggle="tooltip" title="Remove filter" @click="deleteFilter" type="button" >
                    <img class="icon" src="/img/icons/avid-icons/trash-01.svg" alt="Remove">
                </button>
            </div>
            <div v-if="is_searchable" class="dropdown">
                <button class="form-select advanced-filter-dropdown" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-bs-auto-close="outside" data-bs-boundary="viewport" :disabled="local_if_field_disabled">
                    <span class="selected-value" v-if="local_if_field_disabled">Loading Options ...</span>
                    <span class="selected-value" v-else-if="!local_if_field_disabled && local_options_selected && local_options_selected.length > 0"
                        data-bs-toggle="tooltip" :title="field_label+ ': '+ local_options_selected.join(', ')"
                    >{{ local_options_selected.length }} {{local_options_selected.length > 1? 'options': 'option'}} selected</span>
                    <span class="selected-value" v-else>&nbsp;&nbsp;&nbsp;</span>
                </button>
                <div v-if="(filter.options && filter.options.length>0 ) || num_searches > 0 || search_key != ''" class="dropdown-menu dropdown-menu-primary"
                    aria-labelledby="optionDropdown">
                    <!-- search bar -->
                    <div class="input-group" v-if="is_searchable">
                        <div class="search-box position-relative mx-0 flex-fill">
                            <input type="text" placeholder="Search..." aria-label="Search..." v-model="search_key" @input="debouncedSearchOptions()" autocomplete="one-time-code" class=" search-box form-control mx-0 w-100"> 
                            <i class="fa fa-search search-placeholder-icon"></i>
                        </div>
                        <button class="btn btn-secondary" type="button" id="button-addon2" @click="clearSearchKey()"><i class="fas fa-xmark"></i></button>
                    </div>

                    <label v-if="num_searches > 0" class="dropdown-item mt-3">
                        <span class="ms-2" >
                            <div class="spinner-border spinner-border-sm text-primary float-left" role="status"> <span class="visually-hidden">Searching...</span></div> Searching...
                        </span>
                    </label>
                    <label v-else-if="local_options == null || local_options.length == 0 " class="dropdown-item mt-3">
                        <span class="ms-2" >
                            <em>No Results Returned</em>
                        </span>
                    </label>
                    <div v-else>
                        <label class="dropdown-item mt-2" :key="'select_deselect_all'">
                            <input class="form-check-input mt-0" type="checkbox" :checked="if_select_all" @change="toggleSelectAll()">
                            <span class="ms-2" >
                                {{getSelectAllFieldText()}}
                            </span>
                        </label>
                        <div class="dropdown-divider"></div>

                        <label class="dropdown-item d-flex align-items-center" v-for="item in local_options" :key="item" @mouseover="setHover(item, true)" @mouseleave="setHover(item, false)">
                            <input class="form-check-input mt-0" type="checkbox" :value="item" :checked="local_options_selected.includes(item)" :id="item" @change="changeMultiSelection(item)" aria-label="Checkbox">
                            <span class="ms-2 flex-grow-1" >
                                {{ displayOption(item) }}
                            </span>
                            <button class="btn btn-sm btn-white only-selection-btn py-0" v-show="show_only_button[item]" @click.prevent="toggleOnly(item)">ONLY</button>
                        </label>
                    </div>
                </div>
                <div v-else class="dropdown-menu dropdown-menu-primary" aria-labelledby="optionDropdown">
                    <span class="ms-2" >
                        ** All values are blank **
                    </span>
                </div>                
            </div>

            <div v-else>
                <div v-if="local_options == null">
                    <input type="text" class="form-control" disabled="disabled" value="No options exist given the current filters" aria-label="Text input"></input>
                </div>
                <div class="row advanced-filter-dropdown-tile-container" v-else-if="local_options.length == 2 && local_options.includes('true') && local_options.includes('false')">
                    <div class="col-12 tile d-flex ms-3" v-for="item in local_options" > 
                        <div class="tile-content" @click="changeMultiSelection(item)" :id="item">
                            <input class="form-check-input me-2 my-0" type="checkbox" :value="item" v-model="local_options_selected"  aria-label="Local Options Selected">
                            <span v-if="item == 'true'" class="tile-title input-field-description"><i class="fa fa-check fa-xl green"></i>Yes</span>
                            <span v-if="item == 'false'" class="tile-title input-field-description"><i class="fa fa-close fa-xl red" ></i>No</span>
                        </div>
                    </div>
                </div>
                <div class="advanced-filter-dropdown-tile-container" v-else-if="local_options.length == 0 && filter.options && filter.options.length > 0">
                    <input type="text" class="form-control" disabled="disabled" value="Loading options..." aria-label="Text input"></input>
                </div>
                <div class="row advanced-filter-dropdown-tile-container" v-else>
                    <div class="col-12 tile d-flex mx-3" v-for="item in local_options" :key="item">
                        <div class="tile-content" @click="changeMultiSelection(item)" :id="item">
                            <input class="form-check-input me-2 my-0" type="checkbox" :value="item" v-model="local_options_selected"  aria-label="Local Options Selected">
                            <span class="tile-title input-field-description">{{ displayOption(item) }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="advanced-filter-dropdown-single-select" v-else-if="field_type=='single_select' || field_type=='array_single_select'" :hidden="if_field_hidden">
            <div v-if="(filter.options && filter.options.length>0 ) || search_key != ''" class="d-flex justify-content-between align-items-center mb-1">
                <label class="form-label mb-0">{{ field_label }}</label>
                <button v-if="if_allow_delete && !filter.is_required" class="btn btn-icon-only-sm btn-warning p-0 remove-filter-btn" data-bs-toggle="tooltip" title="Remove filter" @click="deleteFilter" type="button" >
                    <img class="icon" src="/img/icons/avid-icons/trash-01.svg" alt="Remove">
                </button>
            </div>
            <div v-if="is_searchable" class="dropdown">
                <button class="form-select advanced-filter-dropdown" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-bs-auto-close="outside" data-bs-boundary="viewport" :disabled="local_if_field_disabled">
                    <span class="selected-value" v-if="local_if_field_disabled">Loading Options ...</span>
                    <span class="selected-value" v-else-if="!local_if_field_disabled && local_options_selected && local_options_selected.length > 0" data-bs-toggle="tooltip" :title="field_label+ ': '+ local_options_selected">{{ local_options_selected}}</span>
                    <span class="selected-value" v-else>&nbsp;&nbsp;&nbsp;</span>     
                </button>
                <div v-if="(filter.options && filter.options.length>0 ) || search_key != ''" class="dropdown-menu dropdown-menu-primary" aria-labelledby="optionDropdown">
                    <!-- search bar -->
                    <div class="input-group pe-2" v-if="is_searchable">
                        <div class="search-box position-relative me-0 flex-fill">
                            <input type="text" placeholder="Search..." aria-label="Search..." v-model="search_key" @input="debouncedSearchOptions()" autocomplete="one-time-code" class=" search-box form-control mx-0 w-100"> 
                            <i class="fa fa-search search-placeholder-icon"></i>
                        </div>
                        <button class="btn btn-secondary" type="button" id="button-addon2" @click="clearSearchKey()"><i class="fas fa-xmark"></i></button>
                    </div>
                    <div class="dropdown-divider" v-if="is_searchable"></div>

                    <label class='d-block' v-for="item in local_options" :key="item">
                        <a class="dropdown-item" href="#" @click.prevent="select(item)">
                            <i class="fa fa-circle-check" v-if="item===local_options_selected"></i>
                            <i class="fa fa-circle-check visually-hidden" v-else></i>
                            <span>
                                {{ displayOption(item) }}
                            </span>                
                        </a>
                    </label>
                </div>  
                <div v-else class="dropdown-menu dropdown-menu-primary" aria-labelledby="optionDropdown">
                    <span class="ms-2" >
                        ** All values are blank **
                    </span>
                </div>                 
            </div>

            <div v-else>
                <div v-if="local_options == null">
                    <input type="text" class="form-control" disabled="disabled" value="No options exist given the current filters" aria-label="Text input"></input>
                </div>
                <div class="row advanced-filter-dropdown-tile-container" v-else-if="local_options.length == 2 && local_options.includes('true') && local_options.includes('false')">
                    <div class="col-12 tile d-flex ms-3" v-for="item in local_options" > 
                        <div class="tile-content" @click="select(item)" :id="item">
                            <input class="form-radio-input me-2 my-0" type="radio" :value="item" v-model="local_options_selected" :name="field_label" aria-label="Field Label">
                            <span v-if="item == 'true'" class="tile-title input-field-description"><i class="fa fa-check fa-xl green"></i>Yes</span>
                            <span v-if="item == 'false'" class="tile-title input-field-description"><i class="fa fa-close fa-xl red" ></i>No</span>
                        </div>
                    </div>
                </div>
                <div class="advanced-filter-dropdown-tile-container" v-else-if="local_options.length == 0 && filter.options && filter.options.length > 0">
                    <input type="text" class="form-control" disabled="disabled" value="Loading options..." aria-label="Text input"></input>
                </div>
                <div class="row advanced-filter-dropdown-tile-container" v-else>
                    <div class="col-12 tile d-flex mx-3" v-for="item in local_options" :key="item">
                        <div class="tile-content" @click="select(item)" :id="item">
                            <input class="form-radio-input me-2 my-0" type="radio" :value="item" v-model="local_options_selected" :name="field_label" aria-label="Field Label">
                            <span class="tile-title input-field-description">{{ displayOption(item) }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div v-else-if="field_type=='date'">
            <label class="form-label">{{ field_label }}</label>
            <datepicker v-model="field.default_value[0]" :use-utc="true" format="MMM d, yyyy" input-class="form-control" ></datepicker> 
        </div> -->
    </div>
</template>

<script>
import vSelect from "vue3-select";
import debounce from 'lodash.debounce';
import VueSlider from 'vue-3-slider-component';

export default {
    props: {
        filter: {
            type: Object,
            required: true
        },
        group_index: {
            default: null,
        },
        field_index: {
            default: null,
        },
        active_group_index: {
            type: Number,
            default: 0
        },
        if_benchmark_report: {
            type: Boolean,
            default: false
        },
        if_allow_delete: {
            type: Boolean,
            default: false
        }
    },
    components: {
        vSelect, VueSlider
    },
    data() {
        return {
            local_options: [],
            local_options_selected: [],
            local_if_field_disabled: false,
            search_key: '',
            if_select_all: false,
            if_field_hidden: false,
            show_only_button: {},
            is_loading: false,
            is_searchable: false,
            debouncedSearchOptions: null,
            num_searches: 0,
            month_order:['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            slider_min: 0,
            slider_max: 1,
            field_label: '',
            field_type: '',
            counts: {},
        };
    },
    watch: {
        filter: {
            handler(newVal) {
                if (!newVal) return;
                this.initializeOptions();
            },
            deep: true,
            immediate: true
        },
        active_group_index: {
            handler(newValue) {
                if (this.search_key !== '') {
                    this.search_key = '';
                    this.searchOptions();
                }

                if (newValue === this.group_index) {
                    this.reorderOptionList();
                }
            }
        },
        'filter.options': {
            handler(newOptions) {
                this.num_searches = 0;
            },
            deep: true
        },
        local_options_selected: {
            handler() {
                this.checkSelectAllStatus();
            },
            deep: true
        }
    },
    created() {
        this.debouncedSearchOptions = debounce(this.searchOptions, 500);
    },
    beforeMount() {
        // Removed redundant initialization
    },
    mounted() {
        // Removed redundant initialization
    },
    methods: {
        initializeOptions() {
            if (!this.filter) return;

            // Capture counts for benchmark display
            if (this.if_benchmark_report && this.filter.counts) {
                this.counts = this.filter.counts;
            }

            this.field_label = this.filter.label;
            this.field_type = this.filter.field_type;
            this.local_if_field_disabled = this.filter.disabled;
            this.db_search = this.filter.db_search;

            // Initialize options - preserve search filtering if search is active
            if (this.filter.options && Array.isArray(this.filter.options)) {
                if (this.search_key && this.search_key.trim() !== '' && !this.filter.db_search) {
                    // If there's an active search, apply the filter to maintain search results
                    this.local_options = this.filter.options.filter((option) => 
                        option.toLowerCase().includes(this.search_key.toLowerCase())
                    );
                } else {
                    this.local_options = [...this.filter.options];
                }
            } else {
                this.local_options = [];
            }

            // Initialize selected value
            if (this.field_type === 'multi_select' || this.field_type === 'month_picker' || this.field_type === 'array_multi_select') {
                let initial = this.filter.value !== undefined
                    ? this.filter.value
                    : this.filter.default_value !== undefined
                        ? this.filter.default_value
                        : [];
                this.local_options_selected = Array.isArray(initial) ? [...initial] : [];
            } else if (this.field_type === 'array_single_select') {
                let initial = this.filter.value !== undefined
                    ? this.filter.value
                    : this.filter.default_value !== undefined
                        ? this.filter.default_value
                        : [];
                if (Array.isArray(initial)) {
                    this.local_options_selected = initial[0] || '';
                } else {
                    this.local_options_selected = initial || '';
                }
            } else if (this.field_type === 'date_range' || this.field_type === 'month_range') {
                this.local_options_selected = this.filter.value || { start_date: "", end_date: "" };
            } else if (this.field_type === 'single_select') {
                if (Array.isArray(this.filter.value)) {
                    this.local_options_selected = this.filter.value[0] || '';
                } else {
                    this.local_options_selected = this.filter.value || '';
                }
            } else {
                this.local_options_selected = this.filter.value || '';
            }

            // Initialize searchable state
            this.is_searchable = (this.filter.options && this.filter.options.length > 5) || this.filter.db_search;

            // Initialize show_only_button
            if (this.filter.options && Array.isArray(this.filter.options)) {
                this.filter.options.forEach(option => {
                    this.show_only_button[option] = false;
                });
            }

            // Initialize slider values
            if (this.field_type === 'numeric_slider' && this.filter.slider_min != null && this.filter.slider_max != null) {
                this.slider_min = Math.floor(this.filter.slider_min);
                this.slider_max = Math.ceil(this.filter.slider_max);

                if(!Array.isArray(this.local_options_selected)){
                    this.local_options_selected = [];
                    this.local_options_selected.push(this.slider_min);
                    this.local_options_selected.push(this.slider_max);
                }
            }
            
            // Update select all status
            this.checkSelectAllStatus();
            
            // Reorder options if needed (for multi-select, array-filter, and single-select)
            if (this.field_type === 'multi_select' || this.field_type === 'array_multi_select' || this.field_type === 'single_select' || this.field_type === 'array_single_select') {
                this.reorderOptionList();
            }
        },
        reorderOptionList(){
            // console.log('reorder');
            // put selected options on top of the list

            if(this.field_type=='multi_select' || this.field_type=='array_multi_select'){
                //If it is an array
                if(Array.isArray(this.local_options_selected) && this.local_options_selected.length > 0){
                    let all_options = [...this.local_options];
                    let option_list_temp = []; // add selected options to the top

                    this.local_options_selected.forEach((selected_value) => {
                        var index = all_options.findIndex((val) => val == selected_value);
                        if(index >= 0){
                            all_options.splice(index, 1);// remove selected options from this.local_options
                            option_list_temp.push(selected_value);
                        }
                    })
                    // add remaining options list back  
                    this.local_options = option_list_temp.concat(all_options);          
                }    
            }

            if(this.field_type=='single_select' || this.field_type=='array_single_select'){
                // Only reorder if there are more than 5 options
                if(this.local_options.length > 5 && this.local_options_selected){
                    let all_options = [...this.local_options];
                    let option_list_temp = []; 
                    option_list_temp.push(this.local_options_selected);// add selected options to the top

                    var index = all_options.findIndex((val) => val == this.local_options_selected);
                    if(index >= 0){
                        all_options.splice(index, 1);// remove selected options from this.local_options
                    }
            
                    // add remaining options list back  
                    this.local_options = option_list_temp.concat(all_options);   
                }     
            }
        },
        changeMultiSelection(option){
            // Ensure local_options_selected is an array
            if(!Array.isArray(this.local_options_selected)){
                this.local_options_selected = [];
            }
            
            // Toggle the option
            if (this.local_options_selected.includes(option)){
                const index = this.local_options_selected.indexOf(option);
                this.local_options_selected.splice(index, 1);
            } else {
                this.local_options_selected.push(option); 
            }
            
            this.emitEvent();
        },
        emitEvent(){
            var filter_details = {
                group_index: this.group_index,
                field_index: this.field_index,
                filter_value: this.field_type === 'single_select'
                    ? (Array.isArray(this.local_options_selected) ? this.local_options_selected[0] : this.local_options_selected)
                    : this.field_type === 'array_single_select'
                        ? (this.local_options_selected ? [this.local_options_selected] : [])
                        : this.local_options_selected
            }
            this.$emit('updateFilter', filter_details);
        },
        removeSelectedOption(item){
            var index = this.local_options_selected.findIndex((element) => element == item);
            this.local_options_selected.splice(index, 1); 
        },
        select(item){
            this.local_options_selected = item;
            this.reorderOptionList();
            this.emitEvent();
        },
        setHover(item, flag){
            this.show_only_button[item] = flag
            this.$forceUpdate();
        },
        changeMonthValue(month){
            //If it is disabled
            if(!this.filter.options.includes(month))
                return;
            if (this.local_options_selected.includes(month)){
                this.local_options_selected = this.local_options_selected.filter((m) => m !== month);
            } else {
                //If this.local_options_selected isn't an array
                if(!Array.isArray(this.local_options_selected)){
                    this.local_options_selected = [];
                }
                this.local_options_selected.push(month);
            }
            this.emitEvent();
        },
        searchOptions(){
            if (!this.filter.db_search){
                if(this.search_key == '') {
                    this.local_options = this.filter.options;
                } else{
                    if(this.field_type=='single_select' || this.field_type=='array_single_select' || this.field_type=='multi_select' || this.field_type=='array_multi_select'){
                        this.local_options = this.filter.options.filter((option) => option.toLowerCase().includes(this.search_key.toLowerCase()));
                    }
                } 
                this.reorderOptionList();                   
            } else {
                this.num_searches++;
                this.$forceUpdate();
                var search_details = {
                    group_index: this.group_index,
                    field_index: this.field_index,
                    search_key: this.search_key
                }
                this.$emit('searchInLongOptionList', search_details);
            }
        },
        clearSearchKey(){
            this.search_key = '';
            if(this.filter.db_search){
                this.searchOptions();
            }
            else {
                this.local_options = this.filter.options;
                // Reorder options to put selected ones at the top
                if (this.field_type === 'multi_select' || this.field_type === 'array_multi_select' || this.field_type === 'single_select' || this.field_type === 'array_single_select') {
                    this.reorderOptionList();
                }
            }
        },
        checkSelectAllStatus(){
            // check if the selected options list contains all option available  
            // if true, select all should be checked
            // else, select all should be unchecked
            if(this.field_type=='multi_select' || this.field_type=='array_multi_select')
                this.if_select_all =this.local_options && this.local_options.every(o => this.local_options_selected.includes(o));
        },
        toggleSelectAll(){
            var self = this;
            
            this.if_select_all = !this.if_select_all;

            if(this.if_select_all){ // select all: add all visible options to selected list
                this.local_options.forEach((option)=>{
                    if (!self.local_options_selected.includes(option))
                        this.local_options_selected.push(option);
                });
            } else { // deselect all: remove all visible options from selected list
                this.local_options.forEach((option)=>{
                    var index = self.local_options_selected.indexOf(option);
                    if (index !== -1) {
                        this.local_options_selected.splice(index, 1);
                    }
                });
            }
            this.emitEvent();
            this.$forceUpdate();
        },
        getSelectAllFieldText(){
            var text = 'Select';
            if(this.search_key==''){
                text += ' All            '
            } else{
                text += ' Visible Options'
            }
            return text;
        }, 
        toggleOnly(option){
            this.local_options_selected = [];
            this.local_options_selected.push(option);
            // uncheck the checkbox for select All
            this.if_select_all = false;
            this.emitEvent();
        },
        getMinMaxFromAPI() {
            // This method is a placeholder for the parent component to call the API
            // The parent component should set filter.slider_min and filter.slider_max
            // Default values if API call fails
            this.slider_min = 0;
            this.slider_max = 1;
        },
        displayOption(option) {
            if (this.if_benchmark_report && this.counts && this.counts[option] !== undefined) {
                return `(${this.counts[option]}) ${option}`;
            }
            return option;
        },
        deleteFilter() {
            var filter_details = {
                group_index: this.group_index,
                field_index: this.field_index
            };
            this.$emit('deleteFilter', filter_details);
        }
    }
}
</script>
